import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  OnDestroy,
  output,
} from '@angular/core';

@Directive({
  selector: '[appViewportObserver]',
})
export class ViewportObserverDirective implements AfterViewInit, OnDestroy {
  isVisible = output<boolean>();
  private firstTime = true;
  private el = inject(ElementRef);
  private observer!: IntersectionObserver;

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (this.firstTime) {
          this.firstTime = false;
          return;
        }
        this.isVisible.emit(entry.isIntersecting);
      },
      { threshold: 0.1 },
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.observer) this.observer.disconnect();
  }
}
